/**
 *    @author:
 *    @since:
 *
 */

import { IValidator } from '../_common/component/IValidator';
import { StartComponent} from './start.component';

export class StartValidation extends IValidator {

       constructor(private component: StartComponent) { super(); }

       private success: boolean;

       public validate(): boolean {

            this.success = true;

            // add your valdation here!

            return this.success;

       }
}

